import axios from "axios";
import getApiBaseUrl from "../GetServer";

interface DemoRequestPayload {
  fullName: string;
  corporateEmail: string;
  phone: string;
  companyName: string;
  jobTitle: string;
  industry: string;
  companySize: string;
  monthlyCustomerQueries: string;
  additionalComments: string | null;
  language: string;
  websiteUrl: string;
}

export const DemoRequest = async (data: DemoRequestPayload): Promise<any> => {
  const baseUrl = getApiBaseUrl();
  const endpoint = `${baseUrl}demo-request/submit-request`;

  try {
    const response = await axios.post(endpoint, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error: any) {
    throw error.response?.data || error.message;
  }
};
